import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Hidden from '@mui/material/Hidden';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import { selectUser } from 'app/store/userSlice';
import ABSUtils from '@abs/utils';
import clsx from 'clsx';

const Root = styled('div')(({ theme }) => ({
  '& .username, & .email': {
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
  },

  '& .avatar': {
    background: theme.palette.background.default,
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
    bottom: 0,
    '& > img': {
      borderRadius: '50%',
    },
  },
}));

function UserNavbarHeader(props) {
  const user = useSelector(selectUser);

  return (
    <Root className={clsx("user relative flex flex-col items-center justify-center pt-8 pb-64 mb-16 z-10 shadow-0",props.className)}>
      <div className="flex items-center justify-center mb-24">
        <Avatar
          sx={user.Color ? { bgcolor: user.Color, color: ABSUtils.invertColor(user.Color, true) } :{
            backgroundColor: 'background.paper',
            color: 'text.secondary',
          }}
          className="avatar text-32 font-bold w-96 h-96"
          src={user.ProfilePicture}
          alt={user.User_Firstname + " " + user.User_Name}
        >
          {ABSUtils.getAvatarFallbackCharArray(user.User_Firstname + " " + user.User_Name)}
        </Avatar>
      </div>
      <Typography className="username text-16 whitespace-nowrap font-semibold mb-4">
        {user.User_Firstname + " " + user.User_Name}
      </Typography>
      <Typography className="email text-13 whitespace-nowrap font-medium" color="text.secondary">
        {user.E_Mail}
      </Typography>
    </Root>
  );
}

export default UserNavbarHeader;
